export default "__VITE_ASSET__C8EBp8dp__"